import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  resultHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  searchContainer: {
    display: 'flex',
    height: 30,
    [theme.breakpoints.up('lg')]: {
      width: 450
    }
  },
  textField: {
    '& input': {
      height: 9
    },
    '& fieldset': {
      borderColor: theme.palette.primary.main
    }
  },
  searchButton: {
    height: '100%',
    boxShadow: 'none'
  },
  liveStatusContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    flexDirection: 'column'
  },
  liveBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.25, 1),
    borderRadius: 999,
    backgroundColor: 'rgba(232, 57, 70, 0.12)',
    border: '1px solid rgba(232, 57, 70, 0.45)'
  },
  liveDot: {
    color: '#E83946',
    fontSize: '1.5rem',
    animation: '$livePulse 1.8s ease-in-out infinite',
    filter: 'drop-shadow(0 0 3px rgba(232, 57, 70, 0.45))'
  },
  liveText: {
    fontWeight: 700,
    letterSpacing: '0.04em',
    color: '#E83946 !important',
    fontSize: '1.5rem'
  },
  '@keyframes livePulse': {
    '0%': {
      opacity: 0.95,
      transform: 'scale(0.95)'
    },
    '50%': {
      opacity: 0.55,
      transform: 'scale(1.08)'
    },
    '100%': {
      opacity: 0.95,
      transform: 'scale(0.95)'
    }
  },
  helperText: {
    margin: theme.spacing(2, 0)
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  },
  select: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    color: theme.palette.primary.main,
    fontWeight: 500,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 0,
    padding: 0,
    '& fieldset': {
      borderColor: theme.palette.secondary.main
    },
    [theme.breakpoints.up('lg')]: {
      width: '32%'
    }
  },
  selectItem: {
    color: theme.palette.primary.main,
    fontWeight: 500
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  table: {
    marginTop: theme.spacing(2),
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    color: theme.palette.primary.main,
    '& th': {
      textAlign: 'left',
      fontSize: '0.75rem',
      padding: theme.spacing(0.75)
    },
    '& td': {
      textAlign: 'left',
      padding: theme.spacing(0.75),
      borderBottom: '1px solid #E6E6E6',
      fontSize: '0.875rem'
    },
    '& tr:nth-child(even)': {
      backgroundColor: '#D9D9D95E'
    },
    '& table': {
      width: '100%'
    },

    '& table th': {
      paddingTop: 0,
      paddingBottom: 0
    },

    [theme.breakpoints.down('md')]: {
      minWidth: 360,
      '& th, & td': {
        fontSize: '0.75rem',
        padding: theme.spacing(0.5)
      }
    }
  },
  expandButtonCol: {
    width: 28
  },
  positionCol: {
    width: 54,
    whiteSpace: 'nowrap'
  },
  competitorCol: {
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    '& a, & p': {
      whiteSpace: 'normal',
      lineHeight: 1.25
    }
  },
  timeCol: {
    whiteSpace: 'nowrap',
    width: 76
  },
  runnerImage: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      borderRadius: 75,
      width: 28,
      height: 28
    }
  },
  runnerName: {
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing(4.2)
    }
  },
  runnerNumberCol: {
    display: 'none',
    color: theme.palette.primary.main,
    [theme.breakpoints.up('lg')]: {
      display: 'table-cell'
    }
  },
  cityNameCol: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'table-cell'
    }
  },
  innerTableCell: {
    backgroundColor: '#ffff',
    padding: 0,
    '& td': {
      borderBottom: 'none'
    }
  },
  expandedContent: {
    padding: theme.spacing(0.5)
  },
  expandedInfoTable: {
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    '& th, & td': {
      textAlign: 'left',
      padding: theme.spacing(0.5),
      borderBottom: 'none'
    },
    '& th': {
      fontSize: '0.7rem'
    }
  },

  lapTimesTitle: {
    display: 'inline-block',
    marginBottom: theme.spacing(0.75),
    fontWeight: 700,
    letterSpacing: '0.04em'
  },
  lapTimesContainer: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch'
  },
  lapTimesTable: {
    borderCollapse: 'separate',
    borderSpacing: theme.spacing(0.5),
    width: 'max-content',
    minWidth: '100%',
    '& th, & td': {
      textAlign: 'center',
      whiteSpace: 'nowrap',
      padding: theme.spacing(0.5, 1),
      borderRadius: 8,
      borderBottom: 'none'
    },
    '& th': {
      backgroundColor: '#F1F3F5',
      fontSize: '.875rem'
    },
    '& td': {
      backgroundColor: '#FFFFFF',
      border: '1px solid #E6E6E6',
      fontSize: '.75rem',
      fontWeight: 600,
      [theme.breakpoints.up('md')]: {
        fontSize: '.875rem'
      }
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing()
  },
  expandButton: {
    padding: 0
  },
  linkUser: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    whiteSpace: 'normal'
  },
  row: {
    '&.expanded': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: theme.palette.primary.contrastText,
      '& a, p': {
        color: theme.palette.primary.contrastText
      }
    }
  }
}))

export default useStyles
